// extracted by mini-css-extract-plugin
export default {"innerWrapper":"vu-z","tooltipWrapper":"wu-z","icon":"xu-z","tooltip":"yu-z","content":"zu-z"};